import { defaultStore, stores } from '../../../../translations';

export default function checkAvailableSymbols(value) {
  return (
    {
      [stores.ru]: () => /[^а-яёА-ЯЁ\s]/.test(value),
      [stores.kz]: () => /[^а-яёА-ЯЁәғқңөүһіӘҒҚҢӨҮҺІ\s]/.test(value),
    }[defaultStore]?.() ?? true
  );
}
